import 'css-chunksrc/client/scenes/assignToTask/tasksSelection/search/styles.scss';export default {
  "search": "_search_1tyyw_1"
};